// firebaseBackend.js
import {initializeApp} from 'firebase/app';
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut,
  onAuthStateChanged,
} from 'firebase/auth';

class FirebaseAuthBackend {
  constructor(firebaseConfig) {
    if (firebaseConfig) {
      this.app = initializeApp(firebaseConfig);
      this.auth = getAuth(this.app);

      onAuthStateChanged(this.auth, (user) => {
        if (user) {
          localStorage.setItem('authUser', JSON.stringify(user));
        } else {
          localStorage.removeItem('authUser');
        }
      });
    }
  }

  registerUser(email, password) {
    return createUserWithEmailAndPassword(this.auth, email, password)
        .then(() => this.auth.currentUser)
        .catch((error) => Promise.reject(this._handleError(error)));
  }

  editProfileAPI(email, password) {
    // Optional: Du kannst hier updateProfile oder andere Methoden nutzen
    return createUserWithEmailAndPassword(this.auth, email, password)
        .then(() => this.auth.currentUser)
        .catch((error) => Promise.reject(this._handleError(error)));
  }

  loginUser(email, password) {
    return signInWithEmailAndPassword(this.auth, email, password)
        .then(() => this.auth.currentUser)
        .catch((error) => Promise.reject(this._handleError(error)));
  }

  forgetPassword(email) {
    const url = `${window.location.protocol}//${window.location.host}/login`;
    return sendPasswordResetEmail(this.auth, email, {url})
        .then(() => true)
        .catch((error) => Promise.reject(this._handleError(error)));
  }

  logout() {
    return signOut(this.auth)
        .then(() => true)
        .catch((error) => Promise.reject(this._handleError(error)));
  }

  setLoggedInUser(user) {
    localStorage.setItem('authUser', JSON.stringify(user));
  }

  getAuthenticatedUser() {
    const user = localStorage.getItem('authUser');
    return user ? JSON.parse(user) : null;
  }

  _handleError(error) {
    return error.message;
  }
}

let _fireBaseBackend = null;

export function initFirebaseBackend(config) {
  if (!_fireBaseBackend) {
    _fireBaseBackend = new FirebaseAuthBackend(config);
  }
  return _fireBaseBackend;
}

export function getFirebaseBackend() {
  return _fireBaseBackend;
}
